/**
 * @name hexToDecimal
 */
export const hexToDecimal = (hex: string): number => parseInt(hex, 16);
